module.exports = __webpack_public_path__ + "static/media/trophy.a4005aaa.svg";